module.exports = __webpack_public_path__ + "media/images/lp_v6_img19-021cff2a600402a7805ada6f46266bd5.webp";